import axios from 'axios';

/**
 * Host-customisable message that is prepended to the invite URL every
 * time a host taps Share / Copy on an invite card. Persisted server-side
 * on the user document via `PUT /api/auth/me/invite-share-message`.
 *
 * Empty stored value ⇒ fall back to `DEFAULT_INVITE_SHARE_MESSAGE`
 * so hosts can reset to defaults by simply wiping the editor field.
 */

export const DEFAULT_INVITE_SHARE_MESSAGE = [
  'Hey, 👋 thanks for booking my place!',
  'I’ll be happy to host you and hope you have a wonderful stay. 😊',
  'Below you’ll find your personal invitation to Allure, giving you access to exclusive discounts at some of the most worth-visiting venues in the area during your stay.',
  'I hope you enjoy discovering the area and experiencing some of the local favorites!',
  'If you need anything before or during your stay, just let me know. I’m happy to help.',
].join('\n');

export const INVITE_SHARE_MESSAGE_MAX = 4000;

/**
 * Build the full text that will be copied / shared for an invite.
 * Layout: <message>\n\n<url>. The URL always sits on its own line so
 * chat / email clients auto-detect and linkify it.
 */
export function composeInviteShareText(message, url) {
  const trimmed = (message ?? '').trim();
  const body = trimmed.length ? trimmed : DEFAULT_INVITE_SHARE_MESSAGE;
  if (!url) return body;
  return `${body}\n\n${url}`;
}

/** Persist a new host-level invite share message. Returns the updated user. */
export async function saveInviteShareMessage(message) {
  const token = localStorage.getItem('token');
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const response = await axios.put(
    `${BACKEND_URL}/api/auth/me/invite-share-message`,
    { message },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
}
